import { TripFolderOlArrival } from '../../lib/types/models/trip-folder/trip-folder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderOlArrivals(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getOlArrivals.url, { id }))
    .get<TripFolderOlArrival[]>()
}
